import HttpFactory from "~/repository/http.factory";
import type { PaginatedResponse } from "~/types/shared/response/paginated.response";
import type { PaginationRequest } from "~/types/shared/request/pagination.request";
import type { CampaignListResponse } from "~/types/campaign/response/campaign.list.response";
import type { ScodiResponse } from "~/types/scodi/response/scodi.response";
import type { FlashResponse } from "~/types/shared/response/flash.response";
import type { FormValidationErrorResponse } from "~/types/shared/response/form.validation.error.response";
import type { SelectInput } from "~/types/shared/select.input";

export default class CampaignClient extends HttpFactory {
  private ADMIN_RESOURCE = "/admin/campaign";
  private CHOICES_RESOURCE = "/choices/campaign";

  private headers: HeadersInit = {
    "Content-type": "application/json",
  };

  async downloadFile(fileUuid: string, campaignUuid: string): Promise<Blob> {
    return await this.call<Blob>(
      this.HTTP_GET,
      `${this.ADMIN_RESOURCE}/${campaignUuid}/file/download/${fileUuid}`,
      this.getAuthenticationHeaders()
    );
  }

  async findAll(
    request?: PaginationRequest
  ): Promise<PaginatedResponse<CampaignListResponse>> {
    return await this.call<PaginatedResponse<CampaignListResponse>>(
      "POST",
      `${this.ADMIN_RESOURCE}/list`,
      this.getAuthenticationHeaders(),
      request
    );
  }

  async get(uuid: string): Promise<ScodiResponse> {
    return await this.call<ScodiResponse>(
      "GET",
      `${this.ADMIN_RESOURCE}/get/${uuid}`,
      this.getAuthenticationHeaders()
    );
  }

  async delete(uuid: string): Promise<FlashResponse> {
    return await this.call<FlashResponse>(
      "DELETE",
      `${this.ADMIN_RESOURCE}/delete/${uuid}`,
      this.getAuthenticationHeaders()
    );
  }

  async getSettingsTypesByMachineType(
    machineType: string
  ): Promise<SelectInput[]> {
    return await this.call<SelectInput[]>(
      "GET",
      `${this.CHOICES_RESOURCE}/settings/${machineType}`,
      this.getAuthenticationHeaders()
    );
  }

  async create(
    request: FormData
  ): Promise<FlashResponse | FormValidationErrorResponse> {
    return await this.call<FlashResponse | FormValidationErrorResponse>(
      "POST",
      `${this.ADMIN_RESOURCE}/create`,
      this.getAuthenticationHeaders(),
      request
    );
  }

  async update(
    request: FormData
  ): Promise<FlashResponse | FormValidationErrorResponse> {
    return await this.call<FlashResponse | FormValidationErrorResponse>(
      "POST",
      `${this.ADMIN_RESOURCE}/update`,
      this.getAuthenticationHeaders(),
      request
    );
  }
}
